import { getOffsets } from '../../util/indexOffsets';

const FLUSH_ALIGN = 'flush';
const SHOW_LINE = true;
const LINE_TYPE = 'solid';
const TEXT = '**{series}**\n{category}, {value}, {point}';
const TEXT_VIDEO = '**{series}**\n{category}, {point}';
const STACKED_COLUMN_TEXT = '**Annotation label**\n{category}';

function getLineEnd(type) {
  return type === 'column' ? 'nothing' : 'dot';
}

function getAttachTo(type, stacking) {
  return type === 'column' && !!stacking ? 'category' : 'point';
}

function getText(type, stacked, isVideo) {
  if (isVideo) return TEXT_VIDEO;
  if (type === 'column' && stacked) return STACKED_COLUMN_TEXT;
  return TEXT;
}

function getInitialState(stateTree) {
  const { documents } = stateTree;
  const { active, items } = documents;
  const { data: chartData, type, groups, sizes } = items[active].chart;
  const { categories, series } = chartData;
  const { seriesOffset, categoryOffset } = getOffsets(chartData);
  const { name, data } = series[seriesOffset];
  const isVideo = groups.includes('Video');
  const isStacked = !!sizes[Object.keys(sizes)[0]].stacking;

  return {
    category: categories[0],
    series: name,
    value: data[categoryOffset].y,
    lineEnd: getLineEnd(type),
    flushAlign: FLUSH_ALIGN,
    showLine: SHOW_LINE,
    lineType: LINE_TYPE,
    attachTo: getAttachTo(type, isStacked),
    text: getText(type, isStacked, isVideo),
  };
}

export { FLUSH_ALIGN, SHOW_LINE, LINE_TYPE, TEXT, TEXT_VIDEO, getLineEnd, getInitialState };
